import type { CostDto, CostCreateDto, CostUpdateDto } from '@camper-diary/shared';
import { api } from './client';

export type Cost = CostDto;

export function listCosts(tripId: string) {
  return api<Cost[]>(`/trips/${encodeURIComponent(tripId)}/costs`);
}

export function createCost(tripId: string, input: CostCreateDto) {
  return api<Cost>(`/trips/${encodeURIComponent(tripId)}/costs`, {
    method: 'POST',
    body: input,
  });
}

export function updateCost(tripId: string, id: string, input: CostUpdateDto) {
  return api<Cost>(
    `/trips/${encodeURIComponent(tripId)}/costs/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: input },
  );
}

export function deleteCost(tripId: string, id: string) {
  return api<null>(
    `/trips/${encodeURIComponent(tripId)}/costs/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  );
}
